module.exports = __webpack_public_path__ + "static/media/heartfelt-funeral-home.8e13e1e8.svg";